import { module } from 'modujs';
import { round } from '../utils/maths';
import { ScrollTrigger } from '../gsap'

export default class Iframe extends module {

    static get settings() {
        return {
            RATIO_CLASS: 'has-ratio'
        }
    }

    constructor(m) {
        super(m);
    }

    init() {
        const $iframe = this.el.children[0]
        const ratio = round($iframe.offsetWidth / $iframe.offsetHeight, 3)
        this.el.style.setProperty('--iframe-ratio', ratio);
        this.el.classList.add(Iframe.settings.RATIO_CLASS);

        requestAnimationFrame(() => ScrollTrigger.refresh());
    }
}
